import React from 'react'
import styled from 'styled-components'
import TopNav from '../../components/navs/TopNav'
import Footer from '../../components/footer/Footer'

const MainLayoutContainer = styled.div`overflow-x: hidden;`
const NavSpacing = styled.div`height: 109px;`

const MainLayout = ({children}) => {
  return (
    <div>
      <MainLayoutContainer className='main-layout'>
        <TopNav />
        <NavSpacing/>
        {children}
      </MainLayoutContainer>
      <Footer/>
    </div>
  )
}

export default MainLayout